<template>
  <v-container fluid>
    <v-layout>
      <v-row>
        <v-col cols="12" md="8" class="pt-0 d-flex justify-center align-center">
          <v-card flat>
              <p class="text-h4 text-center">Pregunta</p>
              <div class="text-h2 text-center font-weight-thin" v-if="getNextQuestionTest">
                {{getNextQuestionTest.pregunta}}
              </div>
              <v-btn loading color="blue" text v-else></v-btn>
            </v-img>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="pt-0">
          <v-list subheader>
            <v-subheader>Respuesta</v-subheader>
            <v-list-item-group v-model="alternativeSelected">
            <v-list-item v-for="(item, index) in respuestas" :active-class="item.color" :key="index" :value="item.value">
              <v-list-item-icon
                ><v-icon>{{item.icon}}</v-icon></v-list-item-icon
              >
              <v-list-item-content>
                <v-list-item-title
                  class="text-body-1 font-weight-light"
                  style="white-space: normal"
                  >{{ item.text }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-btn class="mt-4" block :dark="alternativeSelected !== -1 && !fetching" color="success" :loading ="fetching" :disabled="alternativeSelected === -1 || fetching" @click="registrarRespuesta">Registrar Respuesta</v-btn>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      respuestas: [
        {
          text: "Siempre",
          value: 5,
          icon: "mdi-emoticon-excited-outline",
          color: "green--text text--darken-3"
        },
        {
          text: "Casi siempre",
          value: 4,
          icon: "mdi-emoticon-happy-outline",
          color: "green--text text--lighten-2"
        },
        {
          text: "A veces",
          value: 3,
          icon: "mdi-emoticon-neutral-outline",
          color: "teal--text text--lighten-3"
        },
        {
          text: "Casi nunca",
          value: 2,
          icon: "mdi-emoticon-sad-outline",
          color: "light-blue--text text--lighten-2"
        },
        {
          text: "Nunca",
          value: 1,
          icon: "mdi-emoticon-cry-outline",
          color: "blue--text text--darken-2"
        }
      ],
      alternativeSelected: -1
    };
  },

  computed: {
    ...mapGetters("user", ["getNextQuestionTest", "fetching"])
  },

  methods: {
    async registrarRespuesta() {
      this.cargando = true;
      let respuesta = this.alternativeSelected;
      let body = {
        codigoPregunta: this.getNextQuestionTest.codigoPregunta,
        respuesta: respuesta,
        codigoArea: this.getNextQuestionTest.codigoArea
      };
      let response = await this.submitQuestionTest(body);

      if (response) {
        await this.fetchNextQuestionTest();
        this.alternativeSelected = -1;
        if (this.getNextQuestionTest === "TEST_FINALIZADO") {
          this.$emit("change-step", 2);
        }
      }
    },

    ...mapActions("user", ["submitQuestionTest", "fetchNextQuestionTest"])
  }
};
</script>

<style>
</style>
